import Vue from 'vue';
import VTooltip from 'v-tooltip';

Vue.use(VTooltip, {
    defaultTrigger: 'hover focus click',
    autoHide: false,
});